export const APP_URL = "https://express-accounting.pages.dev";
export const API_URL = "https://api.watch.soft-task.com";
